
/**
 * Environment utilities for Wealthica2 integration
 */

import { getCurrentOrigin } from '@/constants/environments';

/**
 * Cached redirect URI for Wealthica OAuth callbacks
 * Calculated once to avoid repeated DOM access
 */
const REDIRECT_URI = (() => {
  const origin = getCurrentOrigin();
  return `${origin}/investments/connect`;
})();

/**
 * Get the redirect URI for Wealthica OAuth callbacks
 * @returns The redirect URI for the current environment
 */
export function getRedirectUri(): string {
  return REDIRECT_URI;
}

/**
 * Check if we're in development mode
 * @returns True if in development mode
 */
export function isDevelopment(): boolean {
  return import.meta.env.DEV;
}

/**
 * Get the current environment
 * @returns The current environment (development, production, etc.)
 */
export function getEnvironment(): string {
  return import.meta.env.MODE || 'development';
}
